import routes from '@/assets/constants/routes-no.ts';
import { ADVENT_2024_CAMPAIGN_END_DATE } from '@/competitions/2024/advent/config.ts';
import { SUMMER_EXTRA_2024_CAMPAIGN_END_DATE } from '@/competitions/2024/summer-extra/config.ts';
import {
  SUMMER_JULY_2024_COMPETITION_END_DATE,
  SUMMER_JUNE_2024_COMPETITION_END_DATE,
} from '@/competitions/2024/summer/config.ts';
import {
  WAKE_UP_2024_CAMPAIGN_END_DATE,
  WAKE_UP_PART2_2024_CAMPAIGN_END_DATE,
} from '@/competitions/2024/wake-up/config.ts';
import { ADVENT_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/advent/config.ts';
import { AUGUST_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/august/config.ts';
import { FEBRUARY_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/february/config.ts';
import { JANUARY_OPEN_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/january-open/config.ts';
import { JANUARY_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/january/config.ts';
import { JULY_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/july/config.ts';
import { JUNE_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/june/config.ts';
import { MARCH_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/march/config.ts';
import { MAY_MEMBERS_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/may-members/config.ts';
import { MAY_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/may/config.ts';
import { OCTOBER_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/october/config.ts';
import { SEPTEMBER_2025_CAMPAIGN_END_DATE } from '@/competitions/2025/september/config.ts';
import { APRIL_2026_CAMPAIGN_END_DATE } from '@/competitions/2026/april/config.ts';
import { JANUARY_2026_CAMPAIGN_END_DATE } from '@/competitions/2026/january/config.ts';
import { JULY_2026_CAMPAIGN_END_DATE } from '@/competitions/2026/july/config.ts';
import { JUNE_2026_CAMPAIGN_END_DATE } from '@/competitions/2026/june/config.ts';
import { MARCH_2026_CAMPAIGN_END_DATE } from '@/competitions/2026/march/config.ts';
import { SEPTEMBER_2026_CAMPAIGN_END_DATE } from '@/competitions/2026/september/config.ts';
import { createDateInNorwegianTime } from '@/services/new-utils.ts';

import { backgrounds } from './backgrounds/index.ts';
import type { CompetitionTileConfig } from './CompetitionTile.tsx';

const configs: Record<string, Partial<CompetitionTileConfig> | undefined> = {
  advent_of_loans_2023: {
    href: routes.DECEMBER_2023_COMPETITION,
    backgroundColor: '#12453F',
  },
  january_2024_giveaway: {
    href: routes.JANUARY_2024_COMPETITION,
  },
  february_2024_campaign: {
    href: routes.FEBRUARY_2024_COMPETITION,
  },
  march_2024_campaign: {
    href: routes.MARCH_2024_COMPETITION,
    backgroundColor: '#0B8CE3',
  },
  april_2024_campaign: {
    href: routes.APRIL_2024_COMPETITION,
  },
  may_2024_campaign: {
    href: routes.MAY_2024_COMPETITION,
    backgroundColor: '#237D45',
  },
  summer_2024_campaign: {
    href: routes.SUMMER_JUNE_2024_COMPETITION,
    backgroundColor: '#D1ECFE',
    color: '#031839',
    endDate: SUMMER_JUNE_2024_COMPETITION_END_DATE,
    winnersBgColor: '#F0F4FA66',
  },
  summer_2024_campaign_2: {
    href: routes.SUMMER_JULY_2024_COMPETITION,
    backgroundColor: '#D1ECFE',
    color: '#031839',
    endDate: SUMMER_JULY_2024_COMPETITION_END_DATE,
    winnersBgColor: '#F0F4FA66',
  },
  summer_extra_2024_campaign: {
    href: routes.SUMMER_EXTRA_2024_COMPETITION,
    endDate: SUMMER_EXTRA_2024_CAMPAIGN_END_DATE,
    timerTheme: {
      backgroundColor: '#355383',
      digitsColor: '#FFFFFF',
      labelsColor: '#F0F4FA',
    },
  },
  wake_up_2024_campaign: {
    href: routes.WAKE_UP_2024_COMPETITION,
    endDate: WAKE_UP_2024_CAMPAIGN_END_DATE,
    timerTheme: {
      backgroundColor: '#355383',
      digitsColor: '#FFFFFF',
      labelsColor: '#F0F4FA',
    },
  },
  wake_up_2024_campaign_2: {
    href: routes.WAKE_UP_PART2_2024_COMPETITION,
    endDate: WAKE_UP_PART2_2024_CAMPAIGN_END_DATE,
    timerTheme: {
      backgroundColor: '#18A0FB',
      digitsColor: '#FFFFFF',
      labelsColor: '#FFFFFF',
    },
  },
  advent_2024_campaign: {
    href: routes.ADVENT_2024_COMPETITION,
    endDate: ADVENT_2024_CAMPAIGN_END_DATE,
    timerTheme: {
      backgroundColor: '#EC4949',
      digitsColor: '#FFFFFF',
      labelsColor: '#FFFFFF',
    },
  },
  january_2025_campaign: {
    href: routes.JANUARY_2025_COMPETITION,
    endDate: JANUARY_2025_CAMPAIGN_END_DATE,
    timerTheme: {
      backgroundColor: '#355383',
      digitsColor: '#FFFFFF',
      labelsColor: '#F0F4FA',
    },
  },
  january_open_2025_campaign: {
    href: routes.JANUARY_OPEN_2025_COMPETITION,
    endDate: JANUARY_OPEN_2025_CAMPAIGN_END_DATE,
    timerTheme: {
      backgroundColor: '#18A0FB',
      digitsColor: '#FFFFFF',
      labelsColor: '#FFFFFF',
    },
  },
  february_2025_campaign: {
    href: routes.FEBRUARY_2025_COMPETITION,
    endDate: FEBRUARY_2025_CAMPAIGN_END_DATE,
    timerTheme: {
      backgroundColor: '#18A0FB',
      digitsColor: '#FFFFFF',
      labelsColor: '#FFFFFF',
    },
  },
  march_2025_campaign: {
    href: routes.MARCH_2025_COMPETITION,
    endDate: MARCH_2025_CAMPAIGN_END_DATE,
    backgroundColor: '#BAE3FF',
    color: '#031839',
    winnersBgColor: '#F0F4FA66',
    timerTheme: {
      backgroundColor: '#18A0FB',
      digitsColor: '#FFFFFF',
      labelsColor: '#031839',
    },
  },
  may_2025_campaign: {
    href: routes.MAY_2025_COMPETITION,
    endDate: MAY_2025_CAMPAIGN_END_DATE,
    backgroundColor: '#D1ECFE',
    color: '#031839',
    winnersBgColor: '#F0F4FACC',
    timerTheme: {
      backgroundColor: '#354661',
      digitsColor: '#FFFFFF',
      labelsColor: '#031839',
    },
  },
  may_members_2025_campaign: {
    href: routes.MAY_MEMBERS_2025_COMPETITION,
    endDate: MAY_MEMBERS_2025_CAMPAIGN_END_DATE,
    timerTheme: {
      backgroundColor: '#355383',
      digitsColor: '#FFFFFF',
      labelsColor: '#F0F4FA',
    },
  },
  june_2025_campaign: {
    href: routes.JUNE_2025_COMPETITION,
    endDate: JUNE_2025_CAMPAIGN_END_DATE,
    backgroundColor: '#D1ECFE',
    color: '#031839',
    winnersBgColor: '#F0F4FACC',
    timerTheme: {
      backgroundColor: '#354661',
      digitsColor: '#FFFFFF',
      labelsColor: '#031839',
    },
  },
  july_2025_campaign: {
    href: routes.JULY_2025_COMPETITION,
    endDate: JULY_2025_CAMPAIGN_END_DATE,
    backgroundColor: '#072453',
    color: '#FFFFFF',
    winnersBgColor: '#F0F4FA21',
    timerTheme: {
      backgroundColor: '#355383',
      digitsColor: '#FFFFFF',
      labelsColor: '#F0F4FA',
    },
  },
  august_2025_campaign: {
    href: routes.AUGUST_2025_COMPETITION,
    endDate: AUGUST_2025_CAMPAIGN_END_DATE,
    backgroundColor: '#072453',
    color: '#FFFFFF',
    winnersBgColor: '#F0F4FA21',
    timerTheme: {
      backgroundColor: '#355383',
      digitsColor: '#FFFFFF',
      labelsColor: '#F0F4FA',
    },
  },
  september_2025_campaign: {
    href: routes.SEPTEMBER_2025_COMPETITION,
    endDate: SEPTEMBER_2025_CAMPAIGN_END_DATE,
    backgroundColor: '#072453',
    color: '#FFFFFF',
    winnersBgColor: '#F0F4FA21',
    timerTheme: {
      backgroundColor: '#355383',
      digitsColor: '#FFFFFF',
      labelsColor: '#F0F4FA',
    },
  },
  october_2025_campaign: {
    href: routes.OCTOBER_2025_COMPETITION,
    endDate: OCTOBER_2025_CAMPAIGN_END_DATE,
    backgroundColor: '#D1ECFE',
    color: '#031839',
    winnersBgColor: '#FFFFFFCC',
    timerTheme: {
      backgroundColor: '#354661',
      digitsColor: '#FFFFFF',
      labelsColor: '#354661',
    },
  },
  advent_2025_campaign: {
    href: routes.ADVENT_2025_COMPETITION,
    endDate: ADVENT_2025_CAMPAIGN_END_DATE,
    timerTheme: {
      backgroundColor: '#EC4949',
      digitsColor: '#FFFFFF',
      labelsColor: '#FFFFFF',
    },
  },
  january_2026_campaign: {
    href: routes.JANUARY_2026_COMPETITION,
    endDate: JANUARY_2026_CAMPAIGN_END_DATE,
    timerTheme: {
      backgroundColor: '#355383',
      digitsColor: '#FFFFFF',
      labelsColor: '#F0F4FA',
    },
  },
  march_2026_campaign: {
    href: routes.MARCH_2026_COMPETITION,
    endDate: MARCH_2026_CAMPAIGN_END_DATE,
    backgroundColor: '#DBF0FD',
    color: '#18A0FB',
    winnersBgColor: '#FFFFFFCC',
    timerTheme: {
      backgroundColor: '#FFFFFF',
      digitsColor: '#223C66',
      labelsColor: '#223C66',
    },
  },
  april_2026_campaign: {
    href: routes.APRIL_2026_COMPETITION,
    endDate: APRIL_2026_CAMPAIGN_END_DATE,
    backgroundColor: '#18A0FB',
    color: '#FFFFFF',
    winnersBgColor: '#18A0FB',
    timerTheme: {
      backgroundColor: '#FFFFFF',
      digitsColor: '#223C66',
      labelsColor: '#FFFFFF',
    },
  },
  june_2026_campaign: {
    href: routes.JUNE_2026_COMPETITION,
    endDate: JUNE_2026_CAMPAIGN_END_DATE,
    backgroundColor: '#b3e3fa',
    color: '#FFFFFF',
    winnersBgColor: '#5694b8cc',
    timerTheme: {
      backgroundColor: '#FFFFFF',
      digitsColor: '#223C66',
      labelsColor: '#223C66',
    },
  },
  july_2026_campaign: {
    href: routes.JULY_2026_COMPETITION,
    endDate: JULY_2026_CAMPAIGN_END_DATE,
    backgroundColor: '#7c6747',
    color: '#FFFFFF',
    winnersBgColor: '#32353bc5',
    timerTheme: {
      backgroundColor: '#FFFFFF',
      digitsColor: '#223C66',
      labelsColor: '#FFFFFF',
    },
  },
  september_2026_campaign: {
    href: routes.SEPTEMBER_2026_COMPETITION,
    endDate: SEPTEMBER_2026_CAMPAIGN_END_DATE,
    backgroundColor: '#7c6747',
    color: '#FFFFFF',
    winnersBgColor: '#32353bc5',
    timerTheme: {
      backgroundColor: '#FFFFFF',
      digitsColor: '#223C66',
      labelsColor: '#FFFFFF',
    },
  },
};

const defaultConfig = {
  backgroundColor: '#031839',
  href: '/404',
  winnersBgColor: '#0318394D',
} satisfies Partial<CompetitionTileConfig>;

export const getConfig = (slug: string): CompetitionTileConfig => ({
  endDate: createDateInNorwegianTime(1970, 1, 1, 12),
  backgroundSrc: backgrounds[slug] || backgrounds.default,
  backgroundBigSrc: backgrounds[`${slug}-big`],
  ...defaultConfig,
  ...configs[slug],
});
